<template>
  <div>
    <div class="mb-3">
      <div v-if="!loading">
        <div v-if="availableInvitedMembershipTypes.length>0">

          <MembershipType @open-checkout="openCheckout(membershipType)"
                          v-for="membershipType in availableInvitedMembershipTypes"
                          :button-label="membershipType.price!==null ? buttonLabel(membershipType) : $t('buttons.contact_us')"
                          :button-enabled="buttonEnabled(membershipType)"
                          :key="membershipType.id"
                          :membership-type="membershipType"/>
          <outline-button v-if="!membershipsVisible && availableMembershipTypes.length>0" @click="membershipsVisible = true">See all tiers</outline-button>
        </div>

        <div v-if="availableMembershipTypes.length>0 && membershipsVisible">
          <hr v-if="availableInvitedMembershipTypes.length>0 && availableMembershipTypes.length>0">
          <MembershipType @open-checkout="openCheckout(membershipType)"
                          v-for="membershipType in availableMembershipTypes"
                          :button-label="membershipType.price!==null ? buttonLabel(membershipType) : $t('buttons.contact_us')"
                          :button-enabled="buttonEnabled(membershipType)"
                          :key="membershipType.id"
                          :membership-type="membershipType"
                          :show-trial="showTrial"/>
        </div>
        <div v-if="availableMembershipTypes.length==0 && availableInvitedMembershipTypes==0" class="text-danger">
          {{$t('membership.sorry_no_plans_available')}}
        </div>
        <div v-if="unavailableAllMembershipTypes.length>0">
          <hr>
          <p class="text-muted small">
            {{$t('membership.plans_not_available_for_upgrade')}}:
            <span v-for="(membershipType, index) in unavailableAllMembershipTypes" :key="index">
            {{membershipType.name}}<template v-if="index!=unavailableAllMembershipTypes.length-1">, </template>
          </span>
          </p>
        </div>
      </div>
      <div v-else>
        <loading-indicator/>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import MembershipType from "@/components/membership/MembershipType";
import OutlineButton from "../buttons/OutlineButton";
import LoadingIndicator from '@/components/global/LoadingIndicator.vue'

export default {
  props: {
    buttonLabel: {
      type: Function,
      default(/* _membershipType */) {
        return this.$t('buttons.signup')
      }
    },
    buttonEnabled: {
      type: Function,
      default: (/* _membershipType */) => true,
    },
    showAll: {
      type: Boolean,
      default: false,
    },
    showTrial: {
      type: Boolean,
      default: true,
    },
    skipUnavailable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      invitedMembershipTypes: [],
      membershipTypes: [],
      listItems: {},
      membershipsVisible: null,
      loading: true,
    }
  },
  computed: {
    availableInvitedMembershipTypes() {
      return this.invitedMembershipTypes.filter(mt => {
        return !this.skipUnavailable || this.buttonEnabled(mt)
      })
    },
    availableMembershipTypes() {
      return this.membershipTypes.filter(mt => {
        return !this.skipUnavailable || this.buttonEnabled(mt)
      })
    },
    unavailableAllMembershipTypes() {
      return [
          ...this.unavailableInvitedMembershipTypes,
          ...this.unavailableMembershipTypes
      ]
    },
    unavailableInvitedMembershipTypes() {
      return this.invitedMembershipTypes.filter(mt => {
        return this.skipUnavailable && !this.buttonEnabled(mt)
      })
    },
    unavailableMembershipTypes() {
      return this.membershipTypes.filter(mt => {
        return this.skipUnavailable && !this.buttonEnabled(mt)
      })
    },
    ...mapState(['hasMembershipAccess']),
  },
  methods: {
    async loadMemberships() {

      function loadInvitedMemberships() {
        if (this.$store.getters.inviteCodes && this.$store.getters.inviteCodes.length > 0) {
          return this.$store.dispatch('listMembershipTypes', {inviteCodes: this.$store.getters.inviteCodes}).then((membershipTypes) => {
            return membershipTypes;
          });
        } else {
          return Promise.resolve([]);
        }
      }

      function loadMemberships() {
        return this.$store.dispatch('listMembershipTypes', {inviteCodes: []}).then((membershipTypes) => {
          return membershipTypes;
        });
      }

      Promise.all([loadInvitedMemberships.call(this), loadMemberships.call(this)]).then(([invitedMembershipTypes, membershipTypes]) => {
        this.invitedMembershipTypes = invitedMembershipTypes || [];

        function excludeInvitedMemberships(membershipTypes) {
          const invitedMembershipIds = this.invitedMembershipTypes.map(m => m.id);
          return membershipTypes.filter(m => !invitedMembershipIds.includes(m.id))
        }

        this.membershipTypes = excludeInvitedMemberships.call(this, membershipTypes || []);
        if (this.membershipsVisible === null) {
          this.membershipsVisible = this.invitedMembershipTypes.length == 0;
        }
        this.loading = false
      });
    },
    openCheckout (type) {
      if (type.price===null) {
        window.open(`mailto:${process.env.CONTACT_US_EMAIL}?subject=Sign up for "${type.name}`);
      } else {
        this.$store.dispatch('selectMembershipType', type)
        this.$router.push('/checkout/' + type.id)
      }
    }
  },
  components: {
    OutlineButton,
    MembershipType,
    LoadingIndicator,
  },
  mounted () {
    if (this.showAll) {
      this.membershipsVisible = true;
    }
    this.loadMemberships()
    // this.$store.dispatch('loadSquareLib')
    this.$store.dispatch('loadStripeLib')
  }
}
</script>

<style lang="scss" scoped>
hr {
  border-top: 1px solid $border-color;
  margin: 45px 0;
}
.title {
  // font-size: 1.5rem;
  color: $body-color;
}
.membership-container {
  width: 100%;
  margin-top: 30px;

  @media screen and (max-width: 750px) {
    width: 100%;
    // height: 400px;
  }
}

</style>
